import { render } from "./LoupeIcon.vue?vue&type=template&id=26f91086"
const script = {}
script.render = render

export default script